import { authApi } from '@/api';
import { refreshAccessToken } from '@/api/refreshToken';
import { setAccessToken, clearAccessToken } from '@/api/tokenStorage';
import { updateSocketAuth } from '@/services/socketService';

export const authService = {
  async login(credentials) {
    const { data } = await authApi.login(credentials);
    setAccessToken(data.data.accessToken);
    updateSocketAuth(data.data.accessToken);
    return data.data;
  },

  async logout() {
    try {
      await authApi.logout();
    } finally {
      clearAccessToken();
      updateSocketAuth(null);
    }
  },

  async refresh() {
    return refreshAccessToken();
  },

  async getMe() {
    const { data } = await authApi.getMe();
    return data.data.user;
  },

  async changePassword(passwords) {
    const { data } = await authApi.changePassword(passwords);
    clearAccessToken();
    return data;
  },

  async forgotPassword(email) {
    const { data } = await authApi.forgotPassword(email);
    return data;
  },

  async resetPassword(payload) {
    const { data } = await authApi.resetPassword(payload);
    return data;
  },

  async updateProfile(payload) {
    const { data } = await authApi.updateProfile(payload);
    return data.data.user;
  },

  async updatePreferences(payload) {
    const { data } = await authApi.updatePreferences(payload);
    return data.data.user;
  },

  async getLoginHistory() {
    const { data } = await authApi.getLoginHistory();
    return data.data.history;
  },

  async getSessions() {
    const { data } = await authApi.getSessions();
    return data.data.sessions;
  },

  async logoutAll() {
    const { data } = await authApi.logoutAll();
    clearAccessToken();
    return data;
  },

  async getSecurity() {
    const { data } = await authApi.getSecurity();
    return data.data.security;
  },

  async uploadAvatar(file) {
    const { data } = await authApi.uploadAvatar(file);
    return data.data;
  },

  async createUser(payload) {
    const { data } = await authApi.createUser(payload);
    return data.data.user;
  },
};
